var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatureTileIcon03(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shapes") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1---Front-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    transform: "translate(-943.000000, -1211.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tiles",
    transform: "translate(180.000000, 1211.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3,
    transform: "translate(763.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shapes"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#dd1f1f",
    cx: 32,
    cy: 32,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.455,40.91 C24.1045396,39.2027945 21.995033,35.7603372 21.995033,32 C21.995033,28.2396628 24.1045396,24.7972055 27.455,23.09 C27.773145,22.9274442 27.9804006,22.607508 27.9986956,22.2507084 C28.0169906,21.8939089 27.8435456,21.5544522 27.5436956,21.3602084 C27.2438456,21.1659647 26.863145,21.1464442 26.545,21.309 C22.5255295,23.3580245 19.9950017,27.4883878 19.9950017,32 C19.9950017,36.5116122 22.5255295,40.6419755 26.545,42.691 C26.6857385,42.7632755 26.8417893,42.8006591 27,42.8 C27.4627305,42.8009258 27.8656606,42.484262 27.9741354,42.0344248 C28.0826101,41.5845875 27.8682946,41.1190798 27.456,40.909 L27.455,40.91 Z",
    id: "Path",
    fillOpacity: 0.8,
    fill: "#CCD4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.455,21.309 C36.9631904,21.0577104 36.3607896,21.2526904 36.1095,21.7445 C35.8582104,22.2363096 36.0531904,22.8387104 36.545,23.09 C39.8954604,24.7972055 42.004967,28.2396628 42.004967,32 C42.004967,35.7603372 39.8954604,39.2027945 36.545,40.91 C36.1340265,41.1205475 35.9206575,41.5851128 36.028736,42.0340543 C36.1368145,42.4829958 36.5382325,42.7995569 37,42.8 C37.1579551,42.8001897 37.3136488,42.7624665 37.454,42.69 C41.4734705,40.6409755 44.0039983,36.5106122 44.0039983,31.999 C44.0039983,27.4873878 41.4734705,23.3570245 37.454,21.308 L37.455,21.309 Z",
    id: "Path",
    fillOpacity: 0.8,
    fill: "#CCD4FF"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureTileIcon03);
export default __webpack_public_path__ + "static/media/feature-tile-icon-03.dc20198854366cffcf67f6a711c8cd85.svg";
export { ForwardRef as ReactComponent };